<template>
  <slick ref="slick" :options="slickOptions">
    <b-col class="my-3 px-3" v-for="(destination, index) in contents" :key="index">
      <b-card
        :img-src="destination.img"
        :img-alt="destination.country"
        img-top
        tag="article"
      >
        <b-card-text>
          <h4>{{ destination.country }}</h4>
          <h4>{{ destination.price }}</h4>
        </b-card-text>

        <b-button size="sm" variant="outline-primary" @click="emitToParent(destination.city)">Book Now</b-button>
      </b-card>
    </b-col>
  </slick>
</template>

<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'

export default {
  name: 'Carousel_TopDestination',
  props: ['contents'],
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        // options can be used from the plugin documentation
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: '',
        nextArrow: ''
      }
    }
  },
  methods: {
    /* vue slick prerequisites */
    next: function () {
      this.$refs.slick.next()
    },
    prev: function () {
      this.$refs.slick.prev()
    },
    reInit: function () {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.reSlick()
    },
    /* END vue slick prerequisites */
    emitToParent: function (param) {
      this.$emit('passToParent', param)
    }
  }
}
</script>

<style scoped>
.card {
  border-radius: 15px;
  box-shadow: 0px 5px 6px 0px rgba(0, 0, 0, 0.1);
}
.card-img-top {
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
}
.card-body {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Carousel/TopDestination/TopDestination.vue